import React from 'react'
import R from 'ramda'
import PropTypes from 'prop-types'
import {
  Image
} from 'semantic-ui-react'

const getMd5 = R.defaultTo('00000000000000000000000000000000')

const Gravatar = ({
  gravatar = '00000000000000000000000000000000',
  size = 100,
  floated,
  circular,
  style
}) => (
  <Image
    src={`https://secure.gravatar.com/avatar/${getMd5(gravatar)}?s=${size}&d=mm&r=g`}
    floated={R.isNil(floated) ? null : floated}
    circular={R.isNil(circular) ? null : circular}
    style={R.isNil(style) ? null : style}
  />
)

Gravatar.propTypes = {
  gravatar: PropTypes.string,
  floated: PropTypes.string,
  circular: PropTypes.bool,
  style: PropTypes.object,
  size: PropTypes.number
}

export default Gravatar



// WEBPACK FOOTER //
// ./webAdmin/views/gravatar.js